export default {
  primary: '#e0c384',
  secondary: '#e0c384',
  tertiary: '#495057',
  accent: '#82B1FF',
  error: '#f55a4e',
  info: '#baa995',
  success: '#5cb860',
  warning: '#ffa21a'
}
